/**
 * @generated SignedSource<<ee77c9dd8ea1931f82238e382ec9eb93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TimeSig = "VALUE_UNSET" | "t12_8" | "t2_2" | "t2_4" | "t3_4" | "t4_4" | "t6_8" | "t9_8" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UpdateSectionTimeSig_section$data = {
  readonly id: string;
  readonly timeSig: TimeSig;
  readonly " $fragmentType": "UpdateSectionTimeSig_section";
};
export type UpdateSectionTimeSig_section$key = {
  readonly " $data"?: UpdateSectionTimeSig_section$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateSectionTimeSig_section">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateSectionTimeSig_section",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeSig",
      "storageKey": null
    }
  ],
  "type": "SongSection",
  "abstractKey": null
};

(node as any).hash = "fe0401cc900a6f53c9b30c427882307f";

export default node;
